import { Injectable } from '@angular/core';
import { ElementApiService, fullApiPath, ElementsService, IElement } from 'dbweb-core';
import { tap, map } from 'rxjs/operators';
const indexElementName = 'index';
export type CardSize = 'sm' | 'md' | 'lg';
export enum CardType {
	navigation = 'navigation',
	calendar = 'calendar',
	notice = 'notice',
	datalist = 'datalist',
	chart = 'chart'
}
export const defaultCardSize: { [key: string]: CardSize } = {
	[CardType.navigation]: 'sm',
	[CardType.calendar]: 'sm',
	[CardType.notice]: 'sm',
	[CardType.datalist]: 'md',
	[CardType.chart]: 'sm'
};
export type IndexLayout = 'auto' | 'simple';
export interface UserIndexCard {
	Type: CardType;
	Size: CardSize;
	Setting: { [key: string]: any };
}
interface UserIndexSetting {
	Layout: IndexLayout;
	Cards: UserIndexCard[];
	NavigationElements: string[];
}
interface BannerSetting {
	DefaultBannerImage: string;
	Banners: {
		ImageURL: string;
		NavigationURL: string;
	}[];
}
interface UserDiary {
	Day: Date;
	Content: string;
}
interface UserNotice {
	ID: string;
	Title: string;
	Time: Date;
	IsReaded: boolean;
	URL: string;
	Sign: string;
	FrontURL: string; // åç«¯URLè½¬æ¢æåç«¯URL
}
interface FetchMyNoticeResult {
	ElementForBrowseNotice: IElement;
	Data: UserNotice[];
}
@Injectable({ providedIn: 'root' })
export class IndexService {
	userSetting: UserIndexSetting = {} as UserIndexSetting;
	banner: BannerSetting;
	userDiary: UserDiary[];
	notice: UserNotice[];
	inited = false; // æ¯å¦å·²ç»åå§åå®æ¯
	constructor(private api: ElementApiService, private eles: ElementsService) {}
	private fetchIndexSetting() {
		return this.api.get<UserIndexSetting>(indexElementName, 'fetch-index-setting');
	}

	private updateIndexSetting(param: UserIndexSetting) {
		return this.api.post(indexElementName, 'update-index-setting', param);
	}
	private fetchBanner() {
		return this.api.get<BannerSetting>(indexElementName, 'fetch-banner');
	}
	private fetchIndexUserDiary() {
		// éè¦å°åç«¯ä¼ éè¿æ¥çå­ç¬¦ä¸²è½¬æ¢ædateç±»å
		return this.api.get<UserDiary[]>(indexElementName, 'fetch-index-user-diary').pipe(
			map(
				vals =>
					vals
						? vals.map(v => ({
								Day: new Date(v.Day),
								Content: v.Content
								// tslint:disable-next-line: indent
							}))
						: []
			)
		);
	}
	private removeIndexUserDiary(day: Date) {
		return this.api.post<boolean>(indexElementName, 'remove-index-user-diary', day);
	}
	private updateIndexUserDiary(param: UserDiary) {
		return this.api.post<boolean>(indexElementName, 'update-index-user-diary', param);
	}
	private fetchMyNotice() {
		interface IUserNotice {
			ID: string;
			Title: string;
			Time: string;
			IsReaded: boolean;
			URL: string;
			Sign: string;
		}
		interface IFetchMyNoticeResult {
			ElementForBrowseNotice: IElement;
			Data: IUserNotice[];
		}
		return this.api.get<IFetchMyNoticeResult>(indexElementName, 'fetch-my-notice').pipe(
			map(
				v =>
					({
						ElementForBrowseNotice: v.ElementForBrowseNotice,
						Data: v.Data.map(
							sv =>
								({
									ID: sv.ID,
									Title: sv.Title,
									Time: new Date(sv.Time),
									IsReaded: sv.IsReaded,
									URL: sv.URL,
									Sign: sv.Sign
								} as UserNotice)
						)
					} as FetchMyNoticeResult)
			)
		);
	}
	init() {
		this.fetchIndexSetting().subscribe(data => {
			this.userSetting = data || ({} as UserIndexSetting);
			// console.log('======', this.userSetting);
			this.userSetting.Cards = this.userSetting.Cards || [];
			this.userSetting.Layout = this.userSetting.Layout || 'auto';
			// console.log('------', this.userSetting.Layout);
			this.userSetting.NavigationElements = this.userSetting.NavigationElements || [];
			// æ¾ä¸å°çèåé¡¹ï¼æèæ¯æ²¡ææéï¼éè¦å»é¤
			this.userSetting.NavigationElements = this.userSetting.NavigationElements.filter(v => this.eles.get(v));
			this.inited = true;
		});
		this.fetchBanner().subscribe(val => {
			this.banner = val;
			this.banner.DefaultBannerImage = fullApiPath(this.banner.DefaultBannerImage);
		});
	}
	initCalendar() {
		this.fetchIndexUserDiary().subscribe(v => {
			this.userDiary = v;
		});
	}
	initNotice() {
		this.fetchMyNotice().subscribe(v => {
			this.notice = v.Data;
			this.eles.addElement(v.ElementForBrowseNotice);
			v.Data.forEach(one => this.eles.setURLSign(one.URL, one.Sign));
			// ç¶åæè½è®¡ç®åç«¯url
			this.notice.forEach(one => {
				one.FrontURL = this.eles.frontElementURL(v.ElementForBrowseNotice.Name, one.URL);
			});
		});
	}
	updateUserDiary(day: Date, content: string) {
		return this.updateIndexUserDiary({ Day: day, Content: content }).pipe(
			tap(() => {
				const found = this.userDiary.find(v => v.Day.getTime() === day.getTime());
				if (found) {
					found.Content = content;
				} else {
					this.userDiary.push({ Day: day, Content: content });
					this.userDiary.sort((a, b) => {
						return a.Day.getTime() - b.Day.getTime();
					});
				}
			})
		);
	}
	removeUserDiary(day: Date) {
		return this.removeIndexUserDiary(day).pipe(
			tap(() => {
				this.userDiary.splice(this.userDiary.findIndex(v => v.Day.getTime() === day.getTime()), 1);
			})
		);
	}
	updateSetting() {
		return this.updateIndexSetting(this.userSetting);
	}
}
